import React, { useEffect, useState, lazy } from 'react';
export const Story = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const testimonials = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jt5vtcvE3tNUGiLr5UApcy/Generated_Image_October_13%2C_2025_-_8_59PM.png',
    quote: 'This book changed my perspective on what young leaders can accomplish in America today.',
    name: 'Sarah M.',
    location: 'Dallas, TX'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nzgPeocRLgyi9ag2Y5jfe5/Generated_Image_October_13%2C_2025_-_9_01PM.png',
    quote: "Kirk's quotes are exactly what our country needs right now. Truly inspiring!",
    name: 'Michael T.',
    location: 'Nashville, TN'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9KG5aCTp1Cs4pBkuWW3MZk/Generated_Image_October_13%2C_2025_-_8_59PM_%281%29.png',
    quote: "As a teacher, I'm using Kirk's wisdom to inspire the next generation of patriots.",
    name: 'Jennifer L.',
    location: 'Columbus, OH'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kcCXE88WGurQEDpw2S9bMd/Generated_Image_October_13%2C_2025_-_9_02PM.png',
    quote: 'Finally, a book that speaks truth about American values without apology.',
    name: 'Robert K.',
    location: 'Phoenix, AZ'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);
  const goToTestimonial = index => {
    setCurrentTestimonial(index);
  };
  return <div className="py-10 md:py-16 bg-white relative" data-id="element-327">
      {/* American flag corner element */}
      <div className="absolute top-0 right-0 w-16 h-16 md:w-24 md:h-24 overflow-hidden" data-id="element-328">
        <div className="relative w-full h-full" data-id="element-329">
          {/* Red and white stripes */}
          <div className="absolute top-0 left-0 w-full h-full flex flex-col" data-id="element-330">
            {[...Array(13)].map((_, i) => <div key={i} className={`w-full ${i % 2 === 0 ? 'bg-red-700' : 'bg-white'}`} style={{
            height: `${100 / 13}%`
          }} data-id="element-331"></div>)}
          </div>
          {/* Blue canton with stars - now positioned on the left */}
          <div className="absolute top-0 left-0 w-2/5 h-7/13 bg-blue-800" data-id="element-332">
            <div className="w-full h-full flex flex-wrap justify-center items-center p-0.5" data-id="element-333">
              {/* Grid of stars - simplified to 9 stars (3x3 grid) */}
              <div className="grid grid-cols-3 gap-0.5 w-full h-full" data-id="element-334">
                {[...Array(9)].map((_, i) => <div key={i} className="flex items-center justify-center" data-id="element-335">
                    <svg className="w-1.5 h-1.5 md:w-2 md:h-2 text-white" fill="currentColor" viewBox="0 0 24 24" data-id="element-336">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-337" />
                    </svg>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-3 max-w-4xl pt-8 md:pt-4" data-id="element-338">
        <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-8" data-id="element-339">
          Some people chase degrees or elections to gain influence. Charlie Kirk
          didn't need either. Armed only with conviction and a microphone, he
          built a youth movement that championed American values and challenged
          the dominant culture on American campuses.
        </p>
        <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-8" data-id="element-340">
          At just 18, he founded Turning Point USA. What began with a handful of
          students and posters has grown into a national force defending liberty
          and constitutional principles on more than 1,000 campuses.
        </p>
        <p className="text-base md:text-lg text-gray-700 mb-6 md:mb-12" data-id="element-341">
          Today, millions follow him, criticize him, or admire him—but no one
          ignores him. And now his story, strategies, and most powerful quotes
          are revealed in{' '}
          <span className="italic font-medium" data-id="element-342">
            Charlie Kirk: Life, Quotes & Legacy
          </span>
          .
        </p>
        {/* Testimonial Carousel */}
        <div className="mb-8 md:mb-16 relative" data-id="element-343">
          <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-4 md:mb-6 flex items-center justify-center" data-id="element-344">
            <span className="text-red-700 mr-2" data-id="element-345">★</span>
            What Readers Are Saying
            <span className="text-blue-700 ml-2" data-id="element-346">★</span>
          </h3>
          <div className="relative overflow-hidden" data-id="element-347">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentTestimonial * 100}%)`
          }} data-id="element-348">
              {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0" data-id="element-349">
                  <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 p-3 md:p-4 bg-gray-50 rounded-lg shadow-sm border border-gray-100" data-id="element-350">
                    <div className="md:w-1/3 w-1/2 aspect-square overflow-hidden rounded-lg shadow-md" data-id="element-351">
                      <img src={testimonial.image} alt={`${testimonial.name} with Charlie Kirk book`} className="w-full h-full object-cover" loading="lazy" data-id="element-352" />
                    </div>
                    <div className="md:w-2/3 flex flex-col justify-center" data-id="element-353">
                      <blockquote className="text-base md:text-lg italic font-medium text-gray-800 mb-2 md:mb-4" data-id="element-354">
                        "{testimonial.quote}"
                      </blockquote>
                      <div className="text-right" data-id="element-355">
                        <p className="font-semibold text-gray-900" data-id="element-356">
                          {testimonial.name}
                        </p>
                        <p className="text-gray-600 text-sm" data-id="element-357">
                          {testimonial.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation Dots */}
          <div className="flex justify-center mt-3 md:mt-6 space-x-2" data-id="element-358">
            {testimonials.map((_, index) => <button key={index} onClick={() => goToTestimonial(index)} className={`w-2 h-2 md:w-3 md:h-3 rounded-full ${currentTestimonial === index ? 'bg-red-700' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-359" />)}
          </div>
        </div>
        <div className="bg-blue-50 border-l-4 border-blue-700 p-4 md:p-6 mb-6 md:mb-12" data-id="element-360">
          <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-4 flex items-center" data-id="element-361">
            <span className="text-red-700 mr-2" data-id="element-362">★</span>
            The question that changed everything
          </h3>
          <p className="text-base md:text-lg text-gray-700 mb-3 md:mb-4" data-id="element-363">
            At a time when many young people kept quiet out of fear of
            censorship, Kirk asked:
          </p>
          <blockquote className="text-lg md:text-xl italic font-medium text-gray-800 pl-3 md:pl-4 border-l-4 border-red-700 my-4 md:my-6" data-id="element-364">
            "Who is defending freedom in the classroom? Who is standing up for
            students who don't think like the majority?"
          </blockquote>
          <p className="text-base md:text-lg text-gray-700" data-id="element-365">
            That question didn't just spark debate—it sparked a movement to
            restore American values on campus.
          </p>
        </div>
        <div className="flex justify-center my-6 md:my-12 relative" data-id="element-366">
          <div className="absolute inset-0 rounded-lg border-4 border-transparent bg-gradient-to-r from-red-700 via-white to-blue-700 opacity-50" data-id="element-367"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kpS6qqoM4wDHvCviXcS8R7/Generated_Image_October_13%2C_2025_-_2_48PM.png" alt="Charlie Kirk Book on Bookshelf" className="w-full max-w-2xl rounded-lg shadow-lg relative z-10" width="600" height="400" loading="lazy" fetchpriority="low" decoding="async" data-id="element-368" />
        </div>
      </div>
    </div>;
};